import React, { useEffect } from "react";
import Box from "@material-ui/core/Box";
import { B2BSpinner } from "halifax";
import H from "history";
import { clearStoredSessionToken } from "@capone/common";
import { postLogout } from "../../api/v1/auth";

interface ILoadingPageProps {
  language: string;
  history: H.History;
}

const LogoutPage = (_props: ILoadingPageProps) => {
  const logout = async () => {
    try {
      const logoutResponse = await postLogout();
      if (logoutResponse.destinationUrl)
        window.location.replace(logoutResponse.destinationUrl);
    } catch (err) {
      console.log(err);
    } finally {
      // Cleared after the request so it can still authenticate the logout call itself.
      clearStoredSessionToken();
    }
  };

  useEffect(() => {
    logout();
  }, []);

  return (
    <Box className="logout-page-container">
      <B2BSpinner />
    </Box>
  );
};

export default LogoutPage;
